/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum BulkMessagePriorityMassMessageFilter {
    ALL = 'ALL',
    ONLY_PMM = 'ONLY_PMM',
    ONLY_OMM = 'ONLY_OMM',
}
